import { __makeTemplateObject } from "tslib";
/** @jsx jsx */
import { jsx } from "@emotion/react";
import styled from "@emotion/styled";
import { ArrowRightIcon, CheckIcon } from "@smartsheet/lodestar-icons";
import { colors } from "@smartsheet/lodestar-core";
import { TestId } from "../../TestId";
import { getIconForContainerType } from "../../../Utils/getIcons";
var StyledExpandButton = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n        background-color: transparent;\n        border: none;\n        display: inline-block;\n        padding: 0;\n        height: 24px;\n        width: 24px;\n        :focus {\n            outline: none;\n        }\n        ", "\n    }}\n"], ["\n        background-color: transparent;\n        border: none;\n        display: inline-block;\n        padding: 0;\n        height: 24px;\n        width: 24px;\n        :focus {\n            outline: none;\n        }\n        ", "\n    }}\n"])), function (_a) {
    var isExpanded = _a.isExpanded;
    if (isExpanded) {
        return "\n                transform: rotate(90deg);\n            ";
    }
    else {
        return "\n                transform: rotate(0deg);\n            ";
    }
});
export var ContainerListItem = function (_a) {
    var treeItemData = _a.treeItemData, isSelected = _a.isSelected, isExpanded = _a.isExpanded, onExpandClick = _a.onExpandClick, isParentType = _a.isParentType, isCurrentlyFocussed = _a.isCurrentlyFocussed;
    var id = treeItemData.id, containerType = treeItemData.containerType, name = treeItemData.name;
    var itemExpand = function (event) {
        onExpandClick && onExpandClick(treeItemData, event);
    };
    return (jsx("div", { css: {
            display: "flex",
            alignItems: "flex-start",
            flexDirection: "row",
            margin: "3px 0",
            minHeight: "26px",
            flexShrink: 0
        } },
        jsx("div", { css: {
                minWidth: "48px",
                flex: 0,
                textAlign: "right"
            } },
            isSelected && (jsx(CheckIcon, { "data-testid": TestId.CHECK_ICON, color: colors.buttonPrimary })),
            isParentType && (jsx(StyledExpandButton, { "aria-hidden": "true", title: "Expand button", "data-testid": TestId.EXPAND_BUTTON, isExpanded: isExpanded, onClick: itemExpand },
                jsx(ArrowRightIcon, null)))),
        jsx("div", { css: {
                flex: 1,
                display: "flex",
                flexDirection: "row",
                borderRadius: "2px",
                alignItems: "center",
                width: "auto",
                "&:hover": {
                    background: colors.neutralLight20
                },
                background: isCurrentlyFocussed
                    ? colors.neutralLight20
                    : "none"
            }, id: id, "data-testid": TestId.LIST_ITEM },
            jsx("div", { css: { flex: 0, marginRight: "10px" } }, getIconForContainerType(containerType)),
            jsx("div", { css: { flex: 1 } }, name))));
};
var templateObject_1;
//# sourceMappingURL=ContainerListItem.js.map